module.exports = __webpack_public_path__ + "img/7.bc0e70b7.svg";